module.exports = __webpack_public_path__ + "img/parts-defaultIcon.6f5d6c9a.png";